<template>
  <div class="field-supervisor-report">
    <!-- Header del Reporte -->
    <v-card class="mb-6">
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-3">mdi-clipboard-check</v-icon>
        <span class="text-h5">Reporte Field Supervisor</span>
      </v-card-title>

      <v-card-text>
        <h6 class="text-subtitle-1 font-weight-bold">Supervisor: {{ supervisorInfo.name }}</h6>
        <p class="text-body-2 text-medium-emphasis">{{ supervisorInfo.email }}</p>
      </v-card-text>
    </v-card>

    <v-card>
      <v-card-title>
        <v-icon color="primary" class="mr-2">mdi-chart-box-outline</v-icon>
        Métricas del supervisor
      </v-card-title>
      <!--
        P13-V5A-R5 · RETIRED. Las cuatro tarjetas publicaban incidencias resueltas, tiempo
        promedio de resolución, agencias supervisadas (y activas) y rutas optimizadas con su
        "% de eficiencia". Cada valor era el literal 0 con el que se inicializaba
        `reportData` y que `loadReportData()` volvía a asignar con `Object.assign` en cada
        cambio del rango de fechas; no se emitía ninguna petición, de modo que ese 0 no era
        una medición sino la ausencia de productor pintada como cifra. El backend (main
        38d3779b) no monta ningún `/api/reports/field-supervisor`: bajo `/api/reports/*` sólo
        existe `/api/reports/organizational` (app.js:568). Se retiran con ellas el gráfico
        "Performance vs Otros Supervisores", cuyas dos series (Ene-Jul) estaban incrustadas
        como literales en el componente y no procedían de lectura alguna; el gráfico de
        eficiencia por agencia, la tabla de incidencias asignadas y los objetivos del mes,
        alimentados por arrays permanentemente vacíos; y el botón "Exportar", ya
        deshabilitado, cuyo manejador sólo lanzaba un `alert`. Una tarjeta sin productor se
        retira, no se rellena.
      -->
      <v-card-text data-testid="field-supervisor-report-retired">
        <v-alert type="info" variant="tonal" density="compact">
          Estas cifras no tienen un productor canónico y fueron retiradas en P13-V5A-R5. El
          backend no publica ningún reporte de supervisor de campo; los indicadores de zona
          con alcance verificado se consultan en el panel de Field Supervisor.
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useAuthStore } from '@/stores/auth'

// Store
const authStore = useAuthStore()

/**
 * Sólo sobrevive la identidad del actor autenticado, que procede de la sesión. Las
 * interfaces `ReportData` / `MonthlyGoal` / `RecentIncident` / `AgencyEfficiency`, el estado
 * `reportData`, los headers de la tabla de incidencias, las instancias de Chart.js y los
 * helpers de color y formato se eliminaron con los datos que describían: sin productor no
 * hay fila que colorear ni fecha que formatear.
 */
const supervisorInfo = computed(() => ({
  name: authStore.user?.fullName || authStore.userName || 'Supervisor',
  email: authStore.user?.email || ''
}))
</script>

<style scoped>
.field-supervisor-report {
  padding: 16px;
}
</style>
